import api from "../common/services/liferay/api";
import {Liferay} from "../common/services/liferay/liferay";


export const saveDetailCoordinationSettings = async (formCode) => {

    let url = `/api/jsonws/invoke`;

    const resp = await api(url, {
        method: 'POST',
        body: new URLSearchParams({
            cmd: JSON.stringify({
                '/digitalsale.deliverycoordinationsetting/update-coordination-setting': {
                    formCode: formCode,
                    status: true
                },
            }),
            p_auth: Liferay.authToken
        }),
    });

    const data = await resp.json();

    return JSON.parse(data);
}